module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"send_by_email":"Отправить список рекомендаций себе на почту","repeat":"Пройти диагностику еще раз","repeat_text":"При повторном прохождении диагностики, текущая подборка ароматов не сохранится!","send":"Отправить","begin":"Начать диагностику","email_placeholder":"Введите свою почту","subscribe":"Получать новостную рассылку","meta":{"title":"Обонятельная диагностика"}}}')
  delete Component.options._Ctor
}
